import { useQuery } from "@tanstack/react-query";
import { fetchPendingActions, fetchUnresolvedComments, PendingAction, UnresolvedComment } from "@/lib/dashboard-data";
import { useAuth } from "@/contexts/AuthContext";

export function usePendingActions() {
  const { profile, roles } = useAuth();
  const userId = profile?.id;
  const companyId = profile?.company_id;

  const query = useQuery<PendingAction[]>({
    queryKey: ["pending-actions", userId, companyId, roles?.join(",")],
    queryFn: async () => {
      if (!userId || !companyId || !roles) return [];
      return fetchPendingActions(userId, companyId, roles);
    },
    enabled: Boolean(userId && companyId && roles),
  });

  return { ...query, actions: query.data || [] };
}

export function useUnresolvedComments() {
  const { profile, roles } = useAuth();
  const userId = profile?.id;
  const companyId = profile?.company_id;

  const query = useQuery<UnresolvedComment[]>({
    queryKey: ["unresolved-comments", userId, companyId, roles?.join(",")],
    queryFn: async () => {
      if (!userId || !companyId || !roles) return [];
      return fetchUnresolvedComments(userId, companyId, roles);
    },
    enabled: Boolean(userId && companyId && roles),
  });

  return { ...query, comments: query.data || [] };
}


